import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => {
  return {
    button: {
      marginTop: theme.spacing(1.25),
    },
  }
})
